import { axiosInstance } from './axios';

let csrfToken: string | null = null;
let csrfInitialized = false;
let csrfInitPromise: Promise<void> | null = null;

/**
 * Fetch CSRF token from the backend
 * This should be called once on app initialization
 */
export async function initCsrf(): Promise<void> {
  // If already initialized, skip
  if (csrfInitialized) return;

  // If initialization is in progress, wait for it
  if (csrfInitPromise) return csrfInitPromise;

  csrfInitPromise = (async () => {
    try {
      const { data } = await axiosInstance.get<{ csrfToken: string }>('/api/csrf-token');
      csrfToken = data.csrfToken;
      csrfInitialized = true;
    } catch (error) {
      console.error('Failed to fetch CSRF token:', error);
      // Don't throw - CSRF might not be required for all endpoints
      // The app should still work, just without CSRF protection
    }
  })();

  return csrfInitPromise;
}

/**
 * Get the current CSRF token
 */
export function getCsrfToken(): string | null {
  return csrfToken;
}

/**
 * Refresh the CSRF token
 * Call this after login/logout or if you get a CSRF validation error
 */
export async function refreshCsrfToken(): Promise<void> {
  csrfInitialized = false;
  csrfInitPromise = null;
  await initCsrf();
}

/**
 * Check if CSRF token is initialized
 */
export function isCsrfInitialized(): boolean {
  return csrfInitialized;
}
